import { Notification } from '@bosch/react-frok'

import { EmptyHomeProperties } from '@/ui/components/Home/types'

import './EmptyHome.scss'

const EmptyHome = ({ information, translate }: EmptyHomeProperties) => {
    const givenName = information.account?.name || information.account?.username

    return (
        <div className="empty-home">
            <Notification
                icon="info-i-frame"
            >
                <div>
                    <h5 className='title'>{translate('home:emptyPage:title')}</h5>
                    <p>{translate('home:emptyPage:text')}</p>
                    {information &&
                        <p>
                            <span><b>{translate('general:user')}: </b>{givenName}</span><br />
                            <span><b>{translate('general:header:role')}: </b>{information.roles}</span>
                        </p>
                    }
                    <p>{translate('home:emptyPage:contactText')}</p>
                </div>
            </Notification>
        </div>
    )
}

export default EmptyHome